// extracted by mini-css-extract-plugin
export default {"wrapper":"SERPPresencePage_wrapper__HIIYk"};